// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmArchSppUnloadRecord {
constructor({
        id = null,
        emArchCostStatisticId = '',
        emArchBasicDataCode = '',
        emActProcessDefinitionRegisterCode = '',
        businessKey = '',
        sparePartCode = '',
        sparePartPersonalId = '',
        sparePartName = '',
        price = '',
        loadDate = '',
        unloadDate = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.emArchCostStatisticId = emArchCostStatisticId;
    this.emArchBasicDataCode = emArchBasicDataCode;
    this.emActProcessDefinitionRegisterCode = emActProcessDefinitionRegisterCode;
    this.businessKey = businessKey;
    this.sparePartCode = sparePartCode;
    this.sparePartPersonalId = sparePartPersonalId;
    this.sparePartName = sparePartName;
    this.price = price;
    this.loadDate = loadDate;
    this.unloadDate = unloadDate;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchSppUnloadRecord();
}

function gridFields() {
return Object.freeze([
        {
        key: 'emArchCostStatisticId',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.emArchCostStatisticId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchBasicDataCode',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.emArchBasicDataCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchBasicDataName',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.emArchBasicDataName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emActProcessDefinitionRegisterCode',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.emActProcessDefinitionRegisterCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emActProcessDefinitionRegisterName',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.emActProcessDefinitionRegisterName',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'businessKey',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.businessKey',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sparePartCode',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.sparePartCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sparePartPersonalId',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.sparePartPersonalId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sparePartName',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.sparePartName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'price',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.price',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'loadDate',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.loadDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'unloadDate',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.unloadDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'usageDuration',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.usageDuration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '新的' },
                            { value: '2', text: '可维修的' },
                            { value: '3', text: '已维修的' },
                            { value: '4', text: '报废的' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchSppUnloadRecord.grid.remark',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    emArchCostStatisticIdFilter : "",
    emArchBasicDataCodeFilter : "",
    emActProcessDefinitionRegisterCodeFilter : "",
    businessKeyFilter : "",
    sparePartCodeFilter : "",
    sparePartPersonalIdFilter : "",
    sparePartNameFilter : "",
    priceGeFilter : "",
    priceLeFilter : "",
    loadDateGeFilter : "",
    loadDateLeFilter : "",
    unloadDateGeFilter : "",
    unloadDateLeFilter : "",
    usageDurationGeFilter : "",
    usageDurationLeFilter : "",
    statusFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'emArchBasicDataCodeFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.emArchBasicDataCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emActProcessDefinitionRegisterCodeFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.emActProcessDefinitionRegisterCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emActProcessDefinitionRegister'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'sparePartCodeFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.sparePartCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sparePart'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'sparePartPersonalIdFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.sparePartPersonalId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sparePartNameFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.sparePartName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'priceGeFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.priceGe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'priceLeFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.priceLe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'loadDateGeFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.loadDateGe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'loadDateLeFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.loadDateLe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unloadDateGeFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.unloadDateGe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unloadDateLeFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.unloadDateLe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'usageDurationGeFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.usageDurationGe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'usageDurationLeFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.usageDurationLe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.archive.emArchSppUnloadRecord.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '新的' },
                { value: '2', text: '可维修的' },
                { value: '3', text: '已维修的' },
                { value: '4', text: '报废的' }
            ]
        }
        }
];

const entityFormConfigs = [
        {
        key: 'sparePartCode',
        label: 'label.em.archive.emArchSppUnloadRecord.entity.sparePartCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sparePart'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"sparePartName":"name"}'
                }
        },
        {
        key: 'sparePartPersonalId',
        label: 'label.em.archive.emArchSppUnloadRecord.entity.sparePartPersonalId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sparePartName',
        label: 'label.em.archive.emArchSppUnloadRecord.entity.sparePartName',
        sortable: true,
        disabled: true,
        form: {
        type: 'withEntityModalSelect'
                }
        },
        {
        key: 'price',
        label: 'label.em.archive.emArchSppUnloadRecord.entity.price',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'loadDate',
        label: 'label.em.archive.emArchSppUnloadRecord.entity.loadDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'unloadDate',
        label: 'label.em.archive.emArchSppUnloadRecord.entity.unloadDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'status',
        label: 'label.em.archive.emArchSppUnloadRecord.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '新的' },
                { value: '2', text: '可维修的' },
                { value: '3', text: '已维修的' },
                { value: '4', text: '报废的' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchSppUnloadRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmArchSppUnloadRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
